module.exports = __webpack_public_path__ + "static/media/gear_inactive.feeaba2f.svg";